export default {"src":"/_next/static/media/related-product-icon.ffa44365.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};